// TODO: Maybe move these to a separate file now?
export const {
    LOG_LEVEL,
    IS_PRODUCTION,
    TEST_MODE,
    BLINK_PAY_URL,
    BLINK_API_URL,
    PUBLIC_DATA_BASE_URL,
    BUILD_VERSION,
    BUILD_TIMESTAMP,
    WS_API_URL,
    STRIPE_PUBLIC_KEY,
    GOOGLE_PAY_ENV,
    LINKEDIN_CLIENT_ID,
    GOOGLE_CLIENT_ID,
    FACEBOOK_CLIENT_ID,
    TWITTER_CLIENT_ID,

    // TODO: Remove this from configuration files once we support forms in a non-hardcoded way.
    SOUTHERN_THING_ALIAS,
    TNR_ALIAS,

// DEPLOY_CONFIG is replaced at build time with the configuration JSON.
// See the replace({...}) plugin in BundleDescription's getRollupPlugins()
// and getDeployConfig() in buildEnvironment.js
} = DEPLOY_CONFIG;

export const BLINK_SDK_READY_EVENT = "blinkSDKReady";

export const IFRAME_HTML_FILE = "iframe.html";
export const IFRAME_APP_TYPE = {
    widget: "widget",
    panel: "panel",
};

export const IFRAME_TEST_ID = {
    widgetCloseButton: "blinkWidgetCloseButton",
    widgetButton: "blinkWidgetButton",
    iframeElement: "blinkIframe",
};

// TODO: Deprecate donationPage, use donation!
export const PANEL_TYPE = {
    subscribe: "subscribe",
    giftSubscription: "giftSubscription",
    payment: "payment",
    donation: "donation",
    donationPage: "donationPage",
    custom: "custom",
    newsletter: "newsletter",
    dashboard: "dashboard",
    authentication: "internalAuthentication", // TODO @mihai @Darius Rename to authentication
    empty: "empty",
};

// TODO @Darius put all this Gate logic in the panel or somewhere else
export const GATE_TYPE = {
    null: "null", // TODO @mihai @Darius rename to empty
    cover: "cover",
    preview: "preview",
    popup: "popup",
    banner: "banner",
};

export const GATE_COVER_PANEL_POSITION = {
    top: "top",
    center: "center",
    bottom: "bottom",
};

export const DEFAULT_PANEL_CONTAINERS = [
    {
        selector: ".blink-container,#blink-container",
        type: PANEL_TYPE.payment,
        gateType: GATE_TYPE.null,
    },
    {
        selector: ".blink-donation-container,#blink-donation-container",
        type: PANEL_TYPE.donation,
        gateType: GATE_TYPE.null,
    },
    {
        selector: ".blink-subscription-container,#blink-subscription-container",
        type: PANEL_TYPE.subscribe,
        gateType: GATE_TYPE.preview,
    },
    {
        selector: ".blink-purchase-container,#blink-purchase-container",
        type: PANEL_TYPE.payment,
        gateType: GATE_TYPE.preview,
    },
    {
        selector: ".blink-newsletter-container,#blink-newsletter-container",
        type: PANEL_TYPE.newsletter,
        gateType: GATE_TYPE.null,
    },
];
export const PANEL_INSERTED_ATTR = "data-blink-panel-inserted";

export const BLINK_ACTION_URL_PARAM = "blinkaction";
export const BLINK_VERSION_URL_PARAM = "blinkversion";
export const PUBLIC_DATA_SOURCE_PARAM = "blink-public-data-source";

export const USER_JOURNEY_ACTION_TYPE = {
    blinkAction: "blinkAction",
    createPanel: "createPanel",
    editPanel: "editPanel",
    callback: "callback",
    setVariable: "setVariable",
};

export const DONATION_COOLDOWN_PERIOD = 48 * 60 * 60 * 1000; // 48 hours

export const WIDGET_BACKGROUND = "linear-gradient(60deg, #085B68, #064953)";
export const POPUP_GATE_TRANSITION_TIME = 300;
export const POPUP_GATE_TRANSITION = POPUP_GATE_TRANSITION_TIME + "ms opacity cubic-bezier(0.11, 1, 0.76, 1)";
export const WIDGET_TRANSITION = POPUP_GATE_TRANSITION_TIME + "ms ease";
export const WALL_TRANSITION = POPUP_GATE_TRANSITION_TIME + "ms ease";
export const MIN_SUPPORTED_WINDOW_WIDTH = 375;

// TODO maybe we don't need a constant for this?
export const ANALYTICS_ENDPOINT = BLINK_API_URL + "/e/";

export const ANALYTICS_SUBMIT_DEBOUNCE_MS = 100;
export const ANALYTICS_MAX_QUEUED_MESSAGES = 16;

export const MERCHANT_STORAGE_KEY_PREFIX = "blink-|-";

// The whitelist of keys we may add to the host website's localStorage
// or sessionStorage. The real keys used in the storage will have a
// prefix that almost guarantees uniqueness ("blink-|-").
export const MERCHANT_STORAGE_KEYS = {
    loggerLevel: "Logger.loggerLevel",
    onBoardingBehaviour: "UXManager.onboardingBehaviour",
    merchantSessionId: "Analytics.sessionId",
    merchantLocalId: "Analytics.localId",
    selectedUserJourneys: "UJ-selected",
    nthPageVisitConditionState: "UJ-visits-",
    variables: "variables",
    authToken: "authToken",
    utm: "utm",
    referrer: "referrer",
};

export const UTM_PARAM_KEYS = ["medium", "campaign", "source", "term", "content"];

export const INSUFFICIENT_FUNDS_ERROR_CODE = 1207;

export const ACCESS_AUTHORIZATION_REJECTED_ERROR_CODE = 1911;
export const ACCESS_AUTHORIZATION_REJECTED_ERROR_MESSAGE = "The user refused to grant access to his profile details.";

export const PANEL_VARIANT = {
    plain: "plain",
    skipCTA: "skipCTA",
    editRecurring: "editRecurring",
};

export const PANEL_FRAME = {
    none: "none",
    logo: "logo",
};

export const GATE_MOUNT_TYPE = {
    replaceChildren: "replaceChildren",
    firstChild: "firstChild",
    lastChild: "lastChild",
};

export const SOCIAL_APPS = {
    Facebook: "Facebook",
    Google: "Google",
    Twitter: "Twitter",
    LinkedIn: "LinkedIn",
    CDS: "CDS",
};

export const FLOW_TYPE = {
    subscription: "subscription",
    donation: "donation",
    newsletter: "newsletter",
};

export const FLOW_CHECKPOINT = {
    complete: "complete",
};

export const BASE_PANEL_WIDTH = 660;

export const PANEL_CONTENT = {
    [PANEL_TYPE.subscribe]: `
        <PanelFrame style="width: ${BASE_PANEL_WIDTH}px; max-width: 100%">
            <Text></Text>
            <SubscribeButton></SubscribeButton>
            <SubscribeLoginFooter></SubscribeLoginFooter>
            <PoweredByBlink></PoweredByBlink>
        </PanelFrame>`,
    [PANEL_TYPE.donation]: `
        <PanelFrame style="width: ${BASE_PANEL_WIDTH}px; max-width: 100%">
            <Text></Text>
            <DonateButton></DonateButton>
            <DonateLoginFooter></DonateLoginFooter>
            <PoweredByBlink></PoweredByBlink>
        </PanelFrame>`,
    // TODO: The credit value should be taken from the public data.
    [PANEL_TYPE.payment]: `
        <PanelFrame style="width: ${BASE_PANEL_WIDTH}px; max-width: 100%">
            <Text></Text>
            <PurchaseButton></PurchaseButton>
            <If expr="!blinkSDK.isAuthenticated()">
                <Text>Get <b>$2</b> credit when you create an account.</Text>            
            </If>
            <PurchaseLoginFooter></PurchaseLoginFooter>
            <PoweredByBlink></PoweredByBlink>
        </PanelFrame>`,
};
